import axios from "../axios/axios";
import { setBusinessCurrencies, setCurrencies } from "../store/actions/currencyAction";
import { errorDispatcher, setSelectItemLabels } from "../helpers";
import { apiSetAlert } from "./appApi";

export const apiGetCurrencies = (token) => (dispatch, getState) => {
  axios
    .get(`currencies/index`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      const currencies = setSelectItemLabels(response.data.currencies, "id", "fa_title");
      dispatch(setCurrencies(currencies));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch, false);
    });
};

export const apiGetBusinessCurrencies = (token) => (dispatch, getState) => {
  axios
    .get("currencies/list", {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      const currencies = setSelectItemLabels(response.data.currencies, "id", "fa_title");
      const lastUpdatedDate = response.data.lastUpdatedDate;
      dispatch(setBusinessCurrencies(currencies, lastUpdatedDate));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch, false);
    });
};

const invertPrice = (price) => {
  try {
    if (!price) return 0;
    return 1 / Number(price);
  } catch {
    return 0;
  }
};

export const apiUpdateCurrencies = (token, formData, callback) => (dispatch) => {
  const formatedData = formData.map((item) => ({
    id: item.id,
    currencyExchange: item.switched ? invertPrice(item.currencyExchange) : item.currencyExchange,
  }));
  const data = { businessCurrencies: formatedData };
  axios
    .put("/currencies", data, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(apiSetAlert(response.data.message, "success"));
      callback();
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};
